// code borrowed from a project of mine at http://lightsho.ws

var Shortcuts = 
{
  downs: {},
  ups: {},
  capturing: false,
  captured: {key:0, shift:false, alt:false, ctrl:false},
  oncaptured: null,
  oncapturing: null,
  enabled: true,
  blocked: {},
  
  keyFromUser: function(input) 
  {
    return input.key + (input.alt ? 'a' : '_') + (input.shift ? 's' : '_') + (input.ctrl ? 'c' : '_');
  },
  keyFromEvent: function(e) 
  {
    return e.which + (e.altKey ? 'a' : '_') + (e.shiftKey ? 's' : '_') + (e.ctrlKey || e.metaKey ? 'c' : '_');
  },
  
  modifiers: 
  {
    16:  'shift',
    17:  'ctrl',
    18:  'alt', 
    91:  'ctrl',
    92:  'ctrl',
    93:  'ctrl',
    224: 'ctrl'
  },
  
  keydown: function(e) 
  {
    if (this.capturing) {
      this.capturedown(e);
    } else {
      this.handle(e, this.downs);
    }
  },

  keyup: function(e) 
  {
    if (this.capturing) {
      this.captureup(e);
    } else {
      this.handle(e, this.ups);
    }
  },

  handle: function(e, map) 
  {
    if (!this.enabled) {
      return;
    }
    var key = this.keyFromEvent(e);
    if (key in map) {
      if (map[key]() !== false) {
        this.halt(e);
      }
    }
  },

  capturedown: function(e) 
  {
    if (this.blocked[e.which]) {
      return;
    }
    if (e.which in this.modifiers) {
      this.captured[this.modifiers[e.which]] = true;
    } else {
      this.captured.key = e.which; 
    }
    this.capturenotify();
    this.halt(e);
  },

  captureup: function(e) 
  {
    if (this.blocked[e.which]) {
      return;
    }
    if (e.which in this.modifiers) {
      this.captured[this.modifiers[e.which]] = false;
      this.capturenotify();
    } else {
      this.capturing = false;
      this.oncaptured(this.captured);
    }
    this.halt(e);
  },

  capturenotify: function() 
  {
    if (this.oncapturing) {
      this.oncapturing(this.captured);
    }
  },

  halt: function(e) 
  {
    e.preventDefault();
    e.stopPropagation();
  },
  
  init: function() 
  {
    $(document).keydown(function()
    {
      Shortcuts.keydown.apply( Shortcuts, arguments );
    });
    $(document).keyup(function()
    {
      Shortcuts.keyup.apply( Shortcuts, arguments );
    });

    // User can reference keys like: Shortcuts.keys.A
    for (var keycode in this.names) 
    {
      this.keys[ this.names[ keycode ][0] ] = keycode;
    }
  },
  
  down: function(input, callback) 
  {
    this.downs[this.keyFromUser(input)] = callback;
  },
  downoff: function(input) 
  {
    delete this.downs[this.keyFromUser(input)];
  },

  up: function(input, callback) 
  {
    this.ups[this.keyFromUser(input)] = callback;
  },
  upoff: function() 
  {
    delete this.ups[this.keyFromUser(input)];
  },

  off: function() 
  {
    this.downs = {};
    this.ups = {};
  },
  
  capture: function(oncaptured, oncapturing) 
  {
    this.captured = {key:0, shift:false, alt:false, ctrl:false};
    this.oncaptured = oncaptured;
    this.oncapturing = oncapturing;
    this.capturing = true;
  },
  
  inputstring: function(input) 
  {
    return this.keyname(input.key, '?') + (input.shift ? ' + Shift':'') + (input.alt ? ' + Alt':'') + (input.ctrl ? ' + Ctrl':'');
  },
  keyname: function(key, missing) 
  {
    return key in this.names ? this.names[key][0] : (missing || '');
  },
  keychar: function(key, shift, missing) 
  {
    return key in this.names ? this.names[key][shift?2:1] : (missing || '');
  },

  /* Generated by init() */
  keys: {},
  
  /* Name, Char, Char Upper */
  names: {
    8:   ['Backspace', '\b', '\b'],
    9:   ['Tab', '\t', '\t'],
    13:  ['Enter', '\r', '\r'],
    16:  ['Shift', '', ''],
    17:  ['Ctrl', '', ''],
    18:  ['Alt', '', ''],
    19:  ['Pause/Break', '', ''],
    20:  ['Caps Lock', '', ''],
    27:  ['Escape', '', ''],
    33:  ['Page Up', '', ''],
    34:  ['Page Down', '', ''],
    35:  ['End', '', ''],
    36:  ['Home', '', ''],
    37:  ['Left', '', ''],
    38:  ['Up', '', ''],
    39:  ['Right', '', ''],
    40:  ['Down', '', ''],
    45:  ['Insert', '', ''],
    46:  ['Delete', '', ''],
    48:  ['0', '0', ')'],
    49:  ['1', '1', '!'],
    50:  ['2', '2', '@'],
    51:  ['3', '3', '#'],
    52:  ['4', '4', '$'],
    53:  ['5', '5', '%'],
    54:  ['6', '6', '^'],
    55:  ['7', '7', '&'],
    56:  ['8', '8', '*'],
    57:  ['9', '9', '('],
    65:  ['A', 'a', 'A'],
    66:  ['B', 'b', 'B'],
    67:  ['C', 'c', 'C'],
    68:  ['D', 'd', 'D'],
    69:  ['E', 'e', 'E'],
    70:  ['F', 'f', 'F'],
    71:  ['G', 'g', 'G'],
    72:  ['H', 'h', 'H'],
    73:  ['I', 'i', 'I'],
    74:  ['J', 'j', 'J'],
    75:  ['K', 'k', 'K'],
    76:  ['L', 'l', 'L'],
    77:  ['M', 'm', 'M'],
    78:  ['N', 'n', 'N'],
    79:  ['O', 'o', 'O'],
    80:  ['P', 'p', 'P'],
    81:  ['Q', 'q', 'Q'],
    82:  ['R', 'r', 'R'],
    83:  ['S', 's', 'S'],
    84:  ['T', 't', 'T'],
    85:  ['U', 'u', 'U'],
    86:  ['V', 'v', 'V'],
    87:  ['W', 'w', 'W'],
    88:  ['X', 'x', 'X'],
    89:  ['Y', 'y', 'Y'],
    90:  ['Z', 'z', 'Z'],
    91:  ['Left Window Key/Command', '', ''],
    92:  ['Right Window Key/Command', '', ''],
    93:  ['Select/Command', '', ''],
    96:  ['Numpad 0', '0', 'Numpad 0'],
    97:  ['Numpad 1', '1', 'Numpad 1'],
    98:  ['Numpad 2', '2', '2'],
    99:  ['Numpad 3', '3', '3'],
    100: ['Numpad 4', '4', '4'],
    101: ['Numpad 5', '5', '5'],
    102: ['Numpad 6', '6', '6'],
    103: ['Numpad 7', '7', '7'],
    104: ['Numpad 8', '8', '8'],
    105: ['Numpad 9', '9', '9'],
    106: ['Multiply', '*', '*'],
    107: ['Add', '+', '+'],
    109: ['Subtract', '-', '-'],
    110: ['Period', '.', '.'],
    111: ['Divide', '/', '/'],
    112: ['F1', '', ''],
    113: ['F2', '', ''],
    114: ['F3', '', ''],
    115: ['F4', '', ''],
    116: ['F5', '', ''],
    117: ['F6', '', ''],
    118: ['F7', '', ''],
    119: ['F8', '', ''],
    120: ['F9', '', ''],
    121: ['F10', '', ''],
    122: ['F11', '', ''],
    123: ['F12', '', ''],
    144: ['Num Lock', '', ''],
    145: ['Scroll Lock', '', ''],
    186: ['Semi-Colon', ';', ':'],
    187: ['Equal Sign', '=', '+'],
    188: ['Comma', ',', '<'],
    189: ['Dash', '-', '_'],
    190: ['Period', '.', '>'],
    191: ['Forward Slash', '/', '?'],
    192: ['Grave Accent', '`', '~'],
    219: ['Open Bracket', '[', '{'],
    220: ['Back Slash', '\\', '|'],
    221: ['Close Bracket', ']', '}'],
    222: ['Single Quote', '\'', '"']
  }

};